import React, { useState, FormEvent, useContext, useEffect } from "react";
import { Segment, Form, Button, Dropdown, Input, Modal } from "semantic-ui-react";
import { IProject as IProject } from "../../../app/models/project";
import { v4 as uuid } from "uuid";
import MinorStore from "../../../app/stores/minorStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";

const MinorCreateForm: React.FC<RouteComponentProps> = ({
  match,
  history,
}) => {
  const minorStore = useContext(MinorStore);
  const { createProject, generate, submitting } = minorStore;

  const [project, setProject] = useState<IProject>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectCode: "",
    jobType: "Minor",
    category: "",
    customerId: "",
    workType: "",
    siteId: "",
    siteName: "",
    orderNumber: "Not Paid",
    materialOrderNo: "",
    status: "Received",
    address: "",
    receiveDate: "",
    requireDate: "",
    jobStartDate: "",
    estimatedCompletionDate: "",
    invoiceNo: "",
    remark: "",
  });

  const [open, setOpen] = useState(false);

  const handleSubmit = () => {
    createProject(project).then(() =>
      history.push(`/projectmanagement/minor`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProject({ ...project, [name]: value });
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Input
            label="Project Code"
            required
            width="6"
            onChange={handleInputChange}
            name="projectCode"
            placeholder="Project Code"
            value={project.projectCode}
          />
          <Form.Button
            onClick={() =>
              generate().then((code) =>
                setProject({ ...project, ["projectCode"]: code })
              )
            }
            width="2"
            floated="left"
            content="Generate"
            style={{ marginTop: "1.7em" }}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
          label="Work Type"
          required
          onChange={handleInputChange}
          name="workType"
          placeholder="Work Type"
          value={project.workType}
        />
        </Form.Group>
        <Form.Input
          label="Job Location"
          onChange={handleInputChange}
          name="address"
          placeholder="Job Location"
          value={project.address}
        />
        <Form.TextArea
          label="Remark"
          onChange={handleInputChange}
          name="remark"
          rows={2}
          placeholder="Remark"
          value={project.remark}
        />
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/projectmanagement/minor")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(MinorCreateForm);
